// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/banner.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}
/* Apply these styles to your Power BI report container */
.reportContainer {
  width: 1700px; /* Set your desired width in pixels */
  height: 750px; /* Set your desired height in pixels */
  border: 1px solid #ccc; /* Optional: Add a border for visualization */
  margin: 0 auto; /* Optional: Center the container horizontally */
}
.backtolist {
  background-color: #47b7cd;
  color: white;
  padding: 5px 10px 5px 10px;
  border: 1px solid #fff;
  border-radius: 10px;
}
.custome-container {
  width: 1200px !important;
}
/* Style for the Power BI report itself */
.reportClass {
  width: 100%; /* Ensure the report fills the container width */
  height: 100%; /* Ensure the report fills the container height */
}
.login-gradient {
  /* background-image: url("/public/login-banner.png"); */
  background: rgb(87, 195, 207);
  background: linear-gradient(
    90deg,
    rgba(87, 195, 207, 1) 0%,
    rgba(108, 196, 175, 1) 40%,
    rgba(130, 198, 142, 1) 79%
  );
}
.padd {
  padding: 0px !important;
}
.height-100 {
  height: 100vh;
}
.img-100 {
  height: 100%;
  width: 100%;
}

/* .form {
  background-color: white;
  padding: 3.125em;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 5px 5px 15px -1px rgba(0,0,0,0.75);
} */

.logined {
  color: rgb(77, 75, 75);
  letter-spacing: 0px;
  display: block;
  font-weight: bold;
  font-size: x-large;
  margin-bottom: 0.5em;
  padding-top: 26px;
}

.form--input {
  width: 100%;
  margin-bottom: 1.25em;
  height: 40px;
  border-radius: 2px;
  border: 1px solid gray;
  padding: 0.8em;
  font-family: "Inter", sans-serif;
  outline: none;
}

.form--input:focus {
  border: 1px solid #333;
  outline: none;
}

.form--marketing {
  display: flex;
  margin-bottom: 1.25em;
  align-items: center;
}

::placeholder {
  font-size: 14px;
}

.form--marketing > input {
  margin-right: 0.625em;
}

.form--marketing > label {
  color: grey;
  font-size: 14px;
}

.checkbox,
input[type="checkbox"] {
  accent-color: #639;
}

.form--submit {
  width: 100%;
  padding: 0.625em;
  border-radius: 2px;
  color: white;
  background-color: #47b7cd;
  border: 1px solid #47b7cd;
  cursor: pointer;
  font-weight: 500;
}

.form--submit:hover {
  color: #fff;
  border: 1px solid #47b7cd;
  cursor: pointer;
  transition: 0.5s;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}
.center-from {
  width: 420px;
  height: auto;
  position: absolute;
  transform: translate(-50%, -50%);
  background: #fff;
  top: 45%;
  left: 50%;
  z-index: 1099;
}
.sub-span {
  display: inline-block;
  vertical-align: bottom;
  font-size: 14px;
  font-weight: 600;
  font-family: "Montserrat";
  letter-spacing: 0rem;
  line-height: 17px;
  text-align: left;
  color: #70888b;
  padding-left: 5px;
}
.common-p {
  margin: 0;
  padding-bottom: 20px;
  font-size: 15px;
  color: #bfc2c8;
}
.label-input {
  color: #43595e;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 16px;
  font-weight: 500;
}
.forgot {
  text-decoration: none;
  font-size: 14px;
}
.intelligence-text {
  color: #a3dcd7;
  font-size: 41px;
  margin: 0;
  letter-spacing: 0px;
  padding-bottom: 6px;
}
.intelligence-right {
  float: right;
  padding-top: 5%;
}
.logo-size {
  width: 194.63px;
  height: 43px;
  padding: 0px 0.02px 0.12px 0px;
}

.navbar-expand-lg .navbar-collapse {
  justify-content: end;
}
.bg-light {
  background: #fff !important;
}

.notification {
  font-size: 10px;
  margin-left: 0.75rem;
  border-radius: 8px;
  margin: 0px;
  background-color: #de6b7c;
  color: #fff;
  padding: 2px 7px 2px 7px;
  display: inline-block;
  position: absolute;
  top: -2px;
}
.nav-end ul li {
  padding-left: 25px;
  /* padding-right: 10px; */
}
.bell-icon {
  color: #292927;
  font-size: 18px;
}

.banner-sec {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  height: 350px;
  background-repeat: no-repeat;
  width: 100%;
  background-size: cover;
  padding-top: 65px;
}
.banner-text h4 {
  font-weight: 400;
  font-size: 24px;
  color: #fff;
  margin: 0;
  font-family: "Montserrat";
  line-height: 32px;
  letter-spacing: 0rem;
}
.banner-text h3 {
  font-size: 32px;
  color: #fff;
  margin: 0;
  font-family: "Montserrat";
  font-weight: 600;
  line-height: 41px;
  letter-spacing: 0rem;
}
.img-back {
  background: #24a6bc;
  width: 90%;
  padding: 10px;
}
.img-john {
  display: flex;
  margin-right: 2%;
  justify-content: right;
  align-items: center;
}

.bottom-cards {
  margin-top: -103px;
}
.grid {
  width: 100%;
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(5, 1fr);
}
.card {
  margin-bottom: 25px;
  border-width: 1px;
  border: 1px solid #70888b;
  border-radius: 16px;
  background-color: rgb(255, 255, 255);
  padding: 1rem;
  height: -webkit-fill-available;
  position: relative;
}
.card:hover {
  border: 1px solid #cce213;
  box-shadow: 0px 3px 6px 0px rgba(216, 216, 216, 0.75);
}
.card:hover .cardarrow-right {
  visibility: visible;
}
.cardarrow-right {
  width: 40px;
  height: 40px;
  background: #cce213;
  border-radius: 50%;
  color: #202121;
  display: block;
  line-height: 39px;
  text-align: center;
  position: absolute;
  bottom: 0%;
  left: 50%;
  transform: translate(-50%, 46%);
  visibility: hidden;
}
.header {
  display: flex;
  align-items: center;
  grid-gap: 1rem;
  gap: 1rem;
}

.icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background-color: #def2f0;
  padding: 12px;
  color: rgba(255, 255, 255, 1);
  width: 55px;
  height: 55px;
}

.icon svg {
  height: 1rem;
  width: 1rem;
}

.alert {
  font-weight: 600;
  color: rgba(107, 114, 128, 1);
}
.title-card {
  color: #cdcd07;
}
.message {
  text-decoration: none;
  margin-top: 35px;
  color: #202121;
  font-weight: 600;
  display: inline-block;
  margin-bottom: 10px;
  width: 100%;
  font-family: "Montserrat";
  line-height: 23.65px;
  font-size: 17px;
}

.actions {
  margin-top: 1.5rem;
}

.actions a {
  text-decoration: none;
}

.mark-as-read,
.read {
  display: inline-block;
  border-radius: 0.5rem;
  width: 100%;
  padding: 0.75rem 1.25rem;
  text-align: center;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 600;
}

.read {
  background-color: rgba(59, 130, 246, 1);
  color: rgba(255, 255, 255, 1);
}

.mark-as-read {
  margin-top: 0.5rem;
  background-color: rgba(249, 250, 251, 1);
  color: rgba(107, 114, 128, 1);
  transition: all 0.15s ease;
}

.mark-as-read:hover {
  background-color: rgb(230, 231, 233);
}
.reports {
  font-size: 13px;
  color: #9195a0;
  display: inline-block;
}
.w-20 {
  width: 20%;
}
.cursor {
  cursor: pointer;
}
.logout-view {
  background: #fff;
  width: 180px;
  height: auto;
  position: absolute;
  top: 45px;
  right: -33px;
  content: "";
  z-index: 9999;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  box-shadow: 0px 1px 2px 0px rgb(60 64 67 / 30%),
    0px 2px 6px 2px rgb(60 64 67 / 15%);
  display: none;
}
.user-log:hover .logout-view {
  display: block !important;
}
.user-img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: inline-block;
  line-height: 36px;
  border: 1px solid #eee;
}
.logout-up-icon {
  position: absolute;
  top: -31px;
  right: 4%;
  content: "";
  font-size: 29px;
  color: #bebebe;
  padding: 10px;
  width: 60px;
}
.list-items-sign ul {
  margin: 0;
  padding: 0;
}
.list-items-sign ul li {
  padding: 5px 8px 5px 8px;
  display: block;
  text-align: left;
  line-height: 28px;
  cursor: pointer !important;
}
.list-items-sign ul li a {
  display: inline-block;
  font-size: 14px;
  font-weight: normal;
  color: #000;
  text-align: left;
  text-transform: capitalize;
  padding-left: 10px;
  text-decoration: none;
}
.list-items-sign ul li:hover {
  background: #def2f0;
}
.margin-minus {
  margin-top: -330px;
}
.bottom-border {
  border-bottom: 2px solid #f3f1f2;
}
.consumer-analysis {
  padding: 10px 10px 10px 0px;
}
.ul-zero {
  margin: 0;
  padding: 0;
}
.arrow-backs {
  color: #848d8c;
  font-size: 18px;
  vertical-align: bottom;
}
.right-line {
  padding: 0px 19px 0px 5px;
}
.right-lined {
  border-right: 1px solid #3333;
  height: 30px;
}
.market-text {
  color: #182424;
  font-weight: 500;
  margin: 0;
  font-size: 17px;
}
.maximum-view {
  padding: 5px;
  margin: 0;
  border: 1px solid #ddd;
  text-align: center;
  border-radius: 3px;
  color: #7b8181;
}
.w-125 {
  width: 120px;
}
.ver-middle {
  vertical-align: middle;
}
.tabs-bg {
  background: #e0ebed !important;
}
.right-white {
  border-right: 2px solid #fff;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  background: #fff;
  color: #333;
  border-radius: 0px;
  border-top: 3px solid #c6d959;
}
.nav-pills .nav-link {
  color: #102224;
  border-top: 2px solid #e0ebed;
  border-radius: 0px;
  font-weight: 500;
}
.w-723 {
  width: 740px;
}
.padd-left {
  padding-left: 0px;
}
.last-refresh {
  margin: 0;
  font-size: 15px;
  color: #333;
  font-weight: 500;
  padding-right: 10px;
}
.light-text {
  font-weight: 400;
}
.top-10 {
  padding-top: 10px;
}
.position-static {
  display: none !important;
}
.position-static .notification-bar {
  display: none !important;
}
.reportContainer {
  width: 100% !important;
}
.userprofile-name {
  font-family: "Montserrat";
  font-size: 16px;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: 0rem;
  color: #3f5456;
  margin: 0;
  text-transform: capitalize;
}
.left-right-pad {
  padding-left: 15px;
  padding-right: 15px;
}
/* .explorationContainer .exploreCanvas .canvasFlexBox .displayAreaContainer .displayArea{
  width: 100% !important;
    left: 0 !important;
    right: 0;
} */

/* @media only screen and (max-width:767px) {
  .notification {
    font-size: 8px;
    padding: 2px 5px 2px 5px;
    top: -2px;
  }
  .nav-end{
    padding-top: 20px;
    text-align: right;
  }
  .img-back {
    background: #24a6bc;
    width: 70%;
  }
  .banner-text{
    text-align: center;
    padding-bottom: 20px;
  }
  .img-john {
    text-align: center;
    margin-right: 0px;
  }
  .banner-sec {
    height: 250px;
    padding-top: 45px;
  }
  .w-20 {
    width: 50% !important;
  }
  .card {
    width: 100%;
    margin-top: 20px;
    height: 170px;
    word-break: break-word;
    overflow: hidden;
  }
  .message {
    margin-top: 19px;
  }
  .bottom-cards {
    margin-top: 2px !important;
  }
  .intelligence-right {
    float: unset;
    padding-top: 0px;
    padding-bottom: 0px;
}

}


@media only screen and (max-width:1023.98px) {
  .w-20 {
    width: 33%;
  }
  .banner-sec {
    height: 230px;
    width: 100%;
  }
  .img-back {
    width: 80%;
  }
  .bottom-cards {
    margin-top: -68px ;
}
}


@media only screen and (min-width:260px) and (max-width:359.98px) {
  .w-20 {
    width: 100% !important;
  }
  .img-back {
    width: 100%;
  }
  .bottom-cards {
    margin-top: 25px;
  }
} */

section {
  min-height: 100vh;
  width: 100%;
}

.content {
  display: flex;
  flex-direction: row;
  width: 100%;
  background: #fff;
}

.left {
  width: 50%;
  background: rgb(87, 195, 207);
  background: linear-gradient(
    90deg,
    rgba(87, 195, 207, 1) 0%,
    rgba(108, 196, 175, 1) 40%,
    rgba(130, 198, 142, 1) 79%
  );
  overflow: hidden;
}

.left img {
  width: 100%;
  height: 450px;
}

.left h1 {
  margin-top: 10px;
  font-size: 3em;
  font-weight: 100;
  font-family: "Bebas Neue", sans-serif;
  color: #fff;
}

.right {
  padding: 4% 5% 3% 5%;
  width: 50%;
  height: 100%;
}
.right-width {
  width: 420px;
  margin: 0 auto;
}
.inputbox {
  margin: 8px 0px;
  width: 350px;
  height: fit-content;
}
.relative {
  position: relative;
}

input:hover {
  box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.5);
}
 .inputbox label {
  font-size: 1em;
}

/* input::placeholder {
  text-indent: 10px;
} */

.create {
  display: flex;
  justify-content: center;
  width: 360px;
}

.create button {
  margin-top: 5px;
  width: 250px;
  height: 35px;
  border: none;
  border-radius: 25px;

  color: #fff;
  background: #000;
}

.additional p {
  margin-top: 5px;
  font-size: 11px;
  text-align: center;
}

.additional p span {
  color: blue;
}

.additional p span:hover {
  text-decoration: underline;
}

.or {
  margin-top: 10px;
  font-size: 1em;
  text-align: center;
}

.sign {
  display: flex;
  justify-content: space-around;
  margin-top: 15px;
}
.copy-right {
  text-align: center;
  padding-top: 10%;
  font-size: 15px;
  color: #9195a0;
}

.loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.278);
  display: flex;
  justify-content: center;
  align-items: center;
}
.spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.user-btn {
  background: #21a8bf;
  border: 1px solid #21a8bf;
  padding: 3px 10px;
  font-size: 13px;
  border-radius: 16px;
  color: #ffffff;
}
.user-letter {
  background: #21a8bf;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  padding: 5px;
  line-height: 19px;
  color: #fff;
  display: inline-block;
  text-align: center;
  cursor: pointer;
}

/* Responsiveness:Start */
@media screen and (max-width: 780px) {
  .notification {
    font-size: 8px;
    padding: 2px 5px 2px 5px;
    top: -2px;
  }
  .nav-end {
    padding-top: 20px;
    text-align: right;
  }
  .img-back {
    background: #24a6bc;
    width: 70%;
  }
  .banner-text {
    text-align: center;
    padding-bottom: 20px;
  }
  .img-john {
    text-align: center;
    margin-right: 0px;
  }
  .banner-sec {
    height: 250px;
    padding-top: 45px;
  }
  .w-20 {
    width: 50%;
  }
  .card {
    margin-bottom: 5px;
  }
  .message {
    margin-top: 19px;
    word-break: break-word;
    /* width: 132px; */
    font-size: 14px;
  }
  .center-img {
    text-align: center !important;
  }

  .content {
    flex-direction: column;
    width: 80%;
    height: fit-content;
    margin: 20px auto;
  }
  .left {
    height: auto;
    width: 100%;
    border-radius: 0px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .right-width {
    width: 100%;
    margin: 0 auto;
  }
  .right {
    padding: 20px 15px 20px 15px;
    width: 100%;
    border: 1px solid #ccc;
  }
  .left img {
    width: 100%;
    height: 260px;
  }
  .intelligence-right {
    float: none;
    padding: 20px 65px 20px 65px;
  }
  .intelligence-text {
    font-size: 29px;
    text-align: center;
  }
  .copy-right {
    padding-top: 25px;
    font-size: 12px;
  }
  .bottom-cards {
    margin-top: 18px;
  }
  .navbar-toggler {
    border: 0px;
  }
  .navbar-toggler:focus {
    box-shadow: none;
  }
  .logout-view {
    right: -30px;
  }
  .grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media screen and (max-width: 425px) {
  .content {
    width: 100%;
    margin: 0px;
    border-radius: 0px;
  }
  .left {
    width: 100%;
    border-radius: 0px;
  }
  .right-width {
    width: 100%;
    margin: 0 auto;
  }
  .bottom-cards {
    margin-top: 18px;
  }
  .navbar-toggler {
    border: 0px;
  }
  .navbar-toggler:focus {
    box-shadow: none;
  }
}

@media only screen and (max-width: 1023.98px) {
  .w-20 {
    width: 50%;
  }
  .banner-sec {
    height: 230px;
    width: 100%;
  }
  .img-back {
    width: 100%;
  }
  .right-width {
    width: 100%;
    margin: 0 auto;
  }
  .copy-right {
    padding-top: 35px;
  }
  .navbar-toggler {
    border: 0px;
  }
  .navbar-toggler:focus {
    box-shadow: none;
  }
}

@media only screen and (max-width: 1093.98px) {
  .copy-right {
    padding-top: 35px;
  }
  .navbar-toggler {
    border: 0px;
  }
  .navbar-toggler:focus {
    box-shadow: none;
  }
}

@media only screen and (min-width: 224px) and (max-width: 359.98px) {
  .w-20 {
    width: 100% !important;
  }
  .img-back {
    width: 100%;
  }
  .right-width {
    width: 100%;
    margin: 0 auto;
  }
  .copy-right {
    padding-top: 35px;
  }
  .navbar-toggler {
    border: 0px;
  }
  .navbar-toggler:focus {
    box-shadow: none;
  }
  .intelligence-right {
    float: none;
    padding: 20px 8px 20px 8px;
  }
  .intelligence-text {
    text-align: center;
  }
  .logout-view {
    right: -30px;
  }
  .grid {
    grid-template-columns: repeat(1, 1fr);
  }
}

@media only screen and (min-width: 781px) and (max-width: 1021.98px) {
  .bottom-cards {
    margin-top: -50px;
  }
  .w-20 {
    width: 31%;
  }
  .nav-end {
    padding-top: 20px;
    text-align: right;
  }
  .navbar-toggler:focus {
    box-shadow: none;
  }
  .intelligence-right {
    padding: 29px 0px 15px 28px;
  }
  .logout-view {
    right: -30px;
  }
  .grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
/* Responsiveness:End */
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;AACA,yDAAyD;AACzD;EACE,aAAa,EAAE,qCAAqC;EACpD,aAAa,EAAE,sCAAsC;EACrD,sBAAsB,EAAE,6CAA6C;EACrE,cAAc,EAAE,gDAAgD;AAClE;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;AACA,yCAAyC;AACzC;EACE,WAAW,EAAE,gDAAgD;EAC7D,YAAY,EAAE,iDAAiD;AACjE;AACA;EACE,uDAAuD;EACvD,6BAA6B;EAC7B;;;;;GAKC;AACH;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;;;;;;;;GAQG;;AAEH;EACE,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,QAAQ;EACR,SAAS;EACT,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yDAA2C;EAC3C,aAAa;EACb,4BAA4B;EAC5B,WAAW;EACX,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,SAAS;EACT,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,UAAU;EACV,aAAa;AACf;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,aAAa;EACb,SAAS;EACT,qCAAqC;AACvC;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,qBAAqB;EACrB,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,kBAAkB;EAClB;uCACqC;EACrC,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,eAAe;EACf,cAAc;EACd,aAAa;EACb,WAAW;AACb;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,wBAAwB;EACxB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;AACA;EACE,YAAY;EACZ,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,sBAAsB;AACxB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,4BAA4B;AAC9B;AACA;;EAEE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;;;GAIG;;AAEH;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA8EG;;AAEH;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,6BAA6B;EAC7B;;;;;GAKC;EACD,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,YAAY;AACd;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;AAChD;CACC;EACC,cAAc;AAChB;;AAEA;;GAEG;;AAEH;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,mBAAmB;;EAEnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE;IACE,cAAc;IACd,wBAAwB;IACxB,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;IACtB,UAAU;IACV,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,4BAA4B;IAC5B,6BAA6B;EAC/B;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,4BAA4B;IAC5B,WAAW;IACX,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,aAAa;EACf;EACA;IACE,WAAW;IACX,4BAA4B;EAC9B;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,WAAW;IACX,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,aAAa;IACb,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,0BAA0B;EAC5B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,YAAY;EACd;EACA;IACE,qCAAqC;EACvC;AACF;AACA,uBAAuB","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n/* Apply these styles to your Power BI report container */\n.reportContainer {\n  width: 1700px; /* Set your desired width in pixels */\n  height: 750px; /* Set your desired height in pixels */\n  border: 1px solid #ccc; /* Optional: Add a border for visualization */\n  margin: 0 auto; /* Optional: Center the container horizontally */\n}\n.backtolist {\n  background-color: #47b7cd;\n  color: white;\n  padding: 5px 10px 5px 10px;\n  border: 1px solid #fff;\n  border-radius: 10px;\n}\n.custome-container {\n  width: 1200px !important;\n}\n/* Style for the Power BI report itself */\n.reportClass {\n  width: 100%; /* Ensure the report fills the container width */\n  height: 100%; /* Ensure the report fills the container height */\n}\n.login-gradient {\n  /* background-image: url(\"/public/login-banner.png\"); */\n  background: rgb(87, 195, 207);\n  background: linear-gradient(\n    90deg,\n    rgba(87, 195, 207, 1) 0%,\n    rgba(108, 196, 175, 1) 40%,\n    rgba(130, 198, 142, 1) 79%\n  );\n}\n.padd {\n  padding: 0px !important;\n}\n.height-100 {\n  height: 100vh;\n}\n.img-100 {\n  height: 100%;\n  width: 100%;\n}\n\n/* .form {\n  background-color: white;\n  padding: 3.125em;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  box-shadow: 5px 5px 15px -1px rgba(0,0,0,0.75);\n} */\n\n.logined {\n  color: rgb(77, 75, 75);\n  letter-spacing: 0px;\n  display: block;\n  font-weight: bold;\n  font-size: x-large;\n  margin-bottom: 0.5em;\n  padding-top: 26px;\n}\n\n.form--input {\n  width: 100%;\n  margin-bottom: 1.25em;\n  height: 40px;\n  border-radius: 2px;\n  border: 1px solid gray;\n  padding: 0.8em;\n  font-family: \"Inter\", sans-serif;\n  outline: none;\n}\n\n.form--input:focus {\n  border: 1px solid #333;\n  outline: none;\n}\n\n.form--marketing {\n  display: flex;\n  margin-bottom: 1.25em;\n  align-items: center;\n}\n\n::placeholder {\n  font-size: 14px;\n}\n\n.form--marketing > input {\n  margin-right: 0.625em;\n}\n\n.form--marketing > label {\n  color: grey;\n  font-size: 14px;\n}\n\n.checkbox,\ninput[type=\"checkbox\"] {\n  accent-color: #639;\n}\n\n.form--submit {\n  width: 100%;\n  padding: 0.625em;\n  border-radius: 2px;\n  color: white;\n  background-color: #47b7cd;\n  border: 1px solid #47b7cd;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.form--submit:hover {\n  color: #fff;\n  border: 1px solid #47b7cd;\n  cursor: pointer;\n  transition: 0.5s;\n}\n\n.mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n.center-from {\n  width: 420px;\n  height: auto;\n  position: absolute;\n  transform: translate(-50%, -50%);\n  background: #fff;\n  top: 45%;\n  left: 50%;\n  z-index: 1099;\n}\n.sub-span {\n  display: inline-block;\n  vertical-align: bottom;\n  font-size: 14px;\n  font-weight: 600;\n  font-family: \"Montserrat\";\n  letter-spacing: 0rem;\n  line-height: 17px;\n  text-align: left;\n  color: #70888b;\n  padding-left: 5px;\n}\n.common-p {\n  margin: 0;\n  padding-bottom: 20px;\n  font-size: 15px;\n  color: #bfc2c8;\n}\n.label-input {\n  color: #43595e;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  font-size: 16px;\n  font-weight: 500;\n}\n.forgot {\n  text-decoration: none;\n  font-size: 14px;\n}\n.intelligence-text {\n  color: #a3dcd7;\n  font-size: 41px;\n  margin: 0;\n  letter-spacing: 0px;\n  padding-bottom: 6px;\n}\n.intelligence-right {\n  float: right;\n  padding-top: 5%;\n}\n.logo-size {\n  width: 194.63px;\n  height: 43px;\n  padding: 0px 0.02px 0.12px 0px;\n}\n\n.navbar-expand-lg .navbar-collapse {\n  justify-content: end;\n}\n.bg-light {\n  background: #fff !important;\n}\n\n.notification {\n  font-size: 10px;\n  margin-left: 0.75rem;\n  border-radius: 8px;\n  margin: 0px;\n  background-color: #de6b7c;\n  color: #fff;\n  padding: 2px 7px 2px 7px;\n  display: inline-block;\n  position: absolute;\n  top: -2px;\n}\n.nav-end ul li {\n  padding-left: 25px;\n  /* padding-right: 10px; */\n}\n.bell-icon {\n  color: #292927;\n  font-size: 18px;\n}\n\n.banner-sec {\n  background-image: url(\"/public/banner.png\");\n  height: 350px;\n  background-repeat: no-repeat;\n  width: 100%;\n  background-size: cover;\n  padding-top: 65px;\n}\n.banner-text h4 {\n  font-weight: 400;\n  font-size: 24px;\n  color: #fff;\n  margin: 0;\n  font-family: \"Montserrat\";\n  line-height: 32px;\n  letter-spacing: 0rem;\n}\n.banner-text h3 {\n  font-size: 32px;\n  color: #fff;\n  margin: 0;\n  font-family: \"Montserrat\";\n  font-weight: 600;\n  line-height: 41px;\n  letter-spacing: 0rem;\n}\n.img-back {\n  background: #24a6bc;\n  width: 90%;\n  padding: 10px;\n}\n.img-john {\n  display: flex;\n  margin-right: 2%;\n  justify-content: right;\n  align-items: center;\n}\n\n.bottom-cards {\n  margin-top: -103px;\n}\n.grid {\n  width: 100%;\n  display: grid;\n  gap: 1rem;\n  grid-template-columns: repeat(5, 1fr);\n}\n.card {\n  margin-bottom: 25px;\n  border-width: 1px;\n  border: 1px solid #70888b;\n  border-radius: 16px;\n  background-color: rgb(255, 255, 255);\n  padding: 1rem;\n  height: -webkit-fill-available;\n  position: relative;\n}\n.card:hover {\n  border: 1px solid #cce213;\n  box-shadow: 0px 3px 6px 0px rgba(216, 216, 216, 0.75);\n}\n.card:hover .cardarrow-right {\n  visibility: visible;\n}\n.cardarrow-right {\n  width: 40px;\n  height: 40px;\n  background: #cce213;\n  border-radius: 50%;\n  color: #202121;\n  display: block;\n  line-height: 39px;\n  text-align: center;\n  position: absolute;\n  bottom: 0%;\n  left: 50%;\n  transform: translate(-50%, 46%);\n  visibility: hidden;\n}\n.header {\n  display: flex;\n  align-items: center;\n  grid-gap: 1rem;\n  gap: 1rem;\n}\n\n.icon {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px;\n  background-color: #def2f0;\n  padding: 12px;\n  color: rgba(255, 255, 255, 1);\n  width: 55px;\n  height: 55px;\n}\n\n.icon svg {\n  height: 1rem;\n  width: 1rem;\n}\n\n.alert {\n  font-weight: 600;\n  color: rgba(107, 114, 128, 1);\n}\n.title-card {\n  color: #cdcd07;\n}\n.message {\n  text-decoration: none;\n  margin-top: 35px;\n  color: #202121;\n  font-weight: 600;\n  display: inline-block;\n  margin-bottom: 10px;\n  width: 100%;\n  font-family: \"Montserrat\";\n  line-height: 23.65px;\n  font-size: 17px;\n}\n\n.actions {\n  margin-top: 1.5rem;\n}\n\n.actions a {\n  text-decoration: none;\n}\n\n.mark-as-read,\n.read {\n  display: inline-block;\n  border-radius: 0.5rem;\n  width: 100%;\n  padding: 0.75rem 1.25rem;\n  text-align: center;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  font-weight: 600;\n}\n\n.read {\n  background-color: rgba(59, 130, 246, 1);\n  color: rgba(255, 255, 255, 1);\n}\n\n.mark-as-read {\n  margin-top: 0.5rem;\n  background-color: rgba(249, 250, 251, 1);\n  color: rgba(107, 114, 128, 1);\n  transition: all 0.15s ease;\n}\n\n.mark-as-read:hover {\n  background-color: rgb(230, 231, 233);\n}\n.reports {\n  font-size: 13px;\n  color: #9195a0;\n  display: inline-block;\n}\n.w-20 {\n  width: 20%;\n}\n.cursor {\n  cursor: pointer;\n}\n.logout-view {\n  background: #fff;\n  width: 180px;\n  height: auto;\n  position: absolute;\n  top: 45px;\n  right: -33px;\n  content: \"\";\n  z-index: 9999;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 2px;\n  box-shadow: 0px 1px 2px 0px rgb(60 64 67 / 30%),\n    0px 2px 6px 2px rgb(60 64 67 / 15%);\n  display: none;\n}\n.user-log:hover .logout-view {\n  display: block !important;\n}\n.user-img {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: inline-block;\n  line-height: 36px;\n  border: 1px solid #eee;\n}\n.logout-up-icon {\n  position: absolute;\n  top: -31px;\n  right: 4%;\n  content: \"\";\n  font-size: 29px;\n  color: #bebebe;\n  padding: 10px;\n  width: 60px;\n}\n.list-items-sign ul {\n  margin: 0;\n  padding: 0;\n}\n.list-items-sign ul li {\n  padding: 5px 8px 5px 8px;\n  display: block;\n  text-align: left;\n  line-height: 28px;\n  cursor: pointer !important;\n}\n.list-items-sign ul li a {\n  display: inline-block;\n  font-size: 14px;\n  font-weight: normal;\n  color: #000;\n  text-align: left;\n  text-transform: capitalize;\n  padding-left: 10px;\n  text-decoration: none;\n}\n.list-items-sign ul li:hover {\n  background: #def2f0;\n}\n.margin-minus {\n  margin-top: -330px;\n}\n.bottom-border {\n  border-bottom: 2px solid #f3f1f2;\n}\n.consumer-analysis {\n  padding: 10px 10px 10px 0px;\n}\n.ul-zero {\n  margin: 0;\n  padding: 0;\n}\n.arrow-backs {\n  color: #848d8c;\n  font-size: 18px;\n  vertical-align: bottom;\n}\n.right-line {\n  padding: 0px 19px 0px 5px;\n}\n.right-lined {\n  border-right: 1px solid #3333;\n  height: 30px;\n}\n.market-text {\n  color: #182424;\n  font-weight: 500;\n  margin: 0;\n  font-size: 17px;\n}\n.maximum-view {\n  padding: 5px;\n  margin: 0;\n  border: 1px solid #ddd;\n  text-align: center;\n  border-radius: 3px;\n  color: #7b8181;\n}\n.w-125 {\n  width: 120px;\n}\n.ver-middle {\n  vertical-align: middle;\n}\n.tabs-bg {\n  background: #e0ebed !important;\n}\n.right-white {\n  border-right: 2px solid #fff;\n}\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  background: #fff;\n  color: #333;\n  border-radius: 0px;\n  border-top: 3px solid #c6d959;\n}\n.nav-pills .nav-link {\n  color: #102224;\n  border-top: 2px solid #e0ebed;\n  border-radius: 0px;\n  font-weight: 500;\n}\n.w-723 {\n  width: 740px;\n}\n.padd-left {\n  padding-left: 0px;\n}\n.last-refresh {\n  margin: 0;\n  font-size: 15px;\n  color: #333;\n  font-weight: 500;\n  padding-right: 10px;\n}\n.light-text {\n  font-weight: 400;\n}\n.top-10 {\n  padding-top: 10px;\n}\n.position-static {\n  display: none !important;\n}\n.position-static .notification-bar {\n  display: none !important;\n}\n.reportContainer {\n  width: 100% !important;\n}\n.userprofile-name {\n  font-family: \"Montserrat\";\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 32px;\n  letter-spacing: 0rem;\n  color: #3f5456;\n  margin: 0;\n  text-transform: capitalize;\n}\n.left-right-pad {\n  padding-left: 15px;\n  padding-right: 15px;\n}\n/* .explorationContainer .exploreCanvas .canvasFlexBox .displayAreaContainer .displayArea{\n  width: 100% !important;\n    left: 0 !important;\n    right: 0;\n} */\n\n/* @media only screen and (max-width:767px) {\n  .notification {\n    font-size: 8px;\n    padding: 2px 5px 2px 5px;\n    top: -2px;\n  }\n  .nav-end{\n    padding-top: 20px;\n    text-align: right;\n  }\n  .img-back {\n    background: #24a6bc;\n    width: 70%;\n  }\n  .banner-text{\n    text-align: center;\n    padding-bottom: 20px;\n  }\n  .img-john {\n    text-align: center;\n    margin-right: 0px;\n  }\n  .banner-sec {\n    height: 250px;\n    padding-top: 45px;\n  }\n  .w-20 {\n    width: 50% !important;\n  }\n  .card {\n    width: 100%;\n    margin-top: 20px;\n    height: 170px;\n    word-break: break-word;\n    overflow: hidden;\n  }\n  .message {\n    margin-top: 19px;\n  }\n  .bottom-cards {\n    margin-top: 2px !important;\n  }\n  .intelligence-right {\n    float: unset;\n    padding-top: 0px;\n    padding-bottom: 0px;\n}\n\n}\n\n\n@media only screen and (max-width:1023.98px) {\n  .w-20 {\n    width: 33%;\n  }\n  .banner-sec {\n    height: 230px;\n    width: 100%;\n  }\n  .img-back {\n    width: 80%;\n  }\n  .bottom-cards {\n    margin-top: -68px ;\n}\n}\n\n\n@media only screen and (min-width:260px) and (max-width:359.98px) {\n  .w-20 {\n    width: 100% !important;\n  }\n  .img-back {\n    width: 100%;\n  }\n  .bottom-cards {\n    margin-top: 25px;\n  }\n} */\n\nsection {\n  min-height: 100vh;\n  width: 100%;\n}\n\n.content {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  background: #fff;\n}\n\n.left {\n  width: 50%;\n  background: rgb(87, 195, 207);\n  background: linear-gradient(\n    90deg,\n    rgba(87, 195, 207, 1) 0%,\n    rgba(108, 196, 175, 1) 40%,\n    rgba(130, 198, 142, 1) 79%\n  );\n  overflow: hidden;\n}\n\n.left img {\n  width: 100%;\n  height: 450px;\n}\n\n.left h1 {\n  margin-top: 10px;\n  font-size: 3em;\n  font-weight: 100;\n  font-family: \"Bebas Neue\", sans-serif;\n  color: #fff;\n}\n\n.right {\n  padding: 4% 5% 3% 5%;\n  width: 50%;\n  height: 100%;\n}\n.right-width {\n  width: 420px;\n  margin: 0 auto;\n}\n.inputbox {\n  margin: 8px 0px;\n  width: 350px;\n  height: fit-content;\n}\n.relative {\n  position: relative;\n}\n\ninput:hover {\n  box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.5);\n}\n .inputbox label {\n  font-size: 1em;\n}\n\n/* input::placeholder {\n  text-indent: 10px;\n} */\n\n.create {\n  display: flex;\n  justify-content: center;\n  width: 360px;\n}\n\n.create button {\n  margin-top: 5px;\n  width: 250px;\n  height: 35px;\n  border: none;\n  border-radius: 25px;\n\n  color: #fff;\n  background: #000;\n}\n\n.additional p {\n  margin-top: 5px;\n  font-size: 11px;\n  text-align: center;\n}\n\n.additional p span {\n  color: blue;\n}\n\n.additional p span:hover {\n  text-decoration: underline;\n}\n\n.or {\n  margin-top: 10px;\n  font-size: 1em;\n  text-align: center;\n}\n\n.sign {\n  display: flex;\n  justify-content: space-around;\n  margin-top: 15px;\n}\n.copy-right {\n  text-align: center;\n  padding-top: 10%;\n  font-size: 15px;\n  color: #9195a0;\n}\n\n.loader {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.278);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.spinner {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.user-btn {\n  background: #21a8bf;\n  border: 1px solid #21a8bf;\n  padding: 3px 10px;\n  font-size: 13px;\n  border-radius: 16px;\n  color: #ffffff;\n}\n.user-letter {\n  background: #21a8bf;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  padding: 5px;\n  line-height: 19px;\n  color: #fff;\n  display: inline-block;\n  text-align: center;\n  cursor: pointer;\n}\n\n/* Responsiveness:Start */\n@media screen and (max-width: 780px) {\n  .notification {\n    font-size: 8px;\n    padding: 2px 5px 2px 5px;\n    top: -2px;\n  }\n  .nav-end {\n    padding-top: 20px;\n    text-align: right;\n  }\n  .img-back {\n    background: #24a6bc;\n    width: 70%;\n  }\n  .banner-text {\n    text-align: center;\n    padding-bottom: 20px;\n  }\n  .img-john {\n    text-align: center;\n    margin-right: 0px;\n  }\n  .banner-sec {\n    height: 250px;\n    padding-top: 45px;\n  }\n  .w-20 {\n    width: 50%;\n  }\n  .card {\n    margin-bottom: 5px;\n  }\n  .message {\n    margin-top: 19px;\n    word-break: break-word;\n    /* width: 132px; */\n    font-size: 14px;\n  }\n  .center-img {\n    text-align: center !important;\n  }\n\n  .content {\n    flex-direction: column;\n    width: 80%;\n    height: fit-content;\n    margin: 20px auto;\n  }\n  .left {\n    height: auto;\n    width: 100%;\n    border-radius: 0px;\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n  }\n  .right-width {\n    width: 100%;\n    margin: 0 auto;\n  }\n  .right {\n    padding: 20px 15px 20px 15px;\n    width: 100%;\n    border: 1px solid #ccc;\n  }\n  .left img {\n    width: 100%;\n    height: 260px;\n  }\n  .intelligence-right {\n    float: none;\n    padding: 20px 65px 20px 65px;\n  }\n  .intelligence-text {\n    font-size: 29px;\n    text-align: center;\n  }\n  .copy-right {\n    padding-top: 25px;\n    font-size: 12px;\n  }\n  .bottom-cards {\n    margin-top: 18px;\n  }\n  .navbar-toggler {\n    border: 0px;\n  }\n  .navbar-toggler:focus {\n    box-shadow: none;\n  }\n  .logout-view {\n    right: -30px;\n  }\n  .grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n@media screen and (max-width: 425px) {\n  .content {\n    width: 100%;\n    margin: 0px;\n    border-radius: 0px;\n  }\n  .left {\n    width: 100%;\n    border-radius: 0px;\n  }\n  .right-width {\n    width: 100%;\n    margin: 0 auto;\n  }\n  .bottom-cards {\n    margin-top: 18px;\n  }\n  .navbar-toggler {\n    border: 0px;\n  }\n  .navbar-toggler:focus {\n    box-shadow: none;\n  }\n}\n\n@media only screen and (max-width: 1023.98px) {\n  .w-20 {\n    width: 50%;\n  }\n  .banner-sec {\n    height: 230px;\n    width: 100%;\n  }\n  .img-back {\n    width: 100%;\n  }\n  .right-width {\n    width: 100%;\n    margin: 0 auto;\n  }\n  .copy-right {\n    padding-top: 35px;\n  }\n  .navbar-toggler {\n    border: 0px;\n  }\n  .navbar-toggler:focus {\n    box-shadow: none;\n  }\n}\n\n@media only screen and (max-width: 1093.98px) {\n  .copy-right {\n    padding-top: 35px;\n  }\n  .navbar-toggler {\n    border: 0px;\n  }\n  .navbar-toggler:focus {\n    box-shadow: none;\n  }\n}\n\n@media only screen and (min-width: 224px) and (max-width: 359.98px) {\n  .w-20 {\n    width: 100% !important;\n  }\n  .img-back {\n    width: 100%;\n  }\n  .right-width {\n    width: 100%;\n    margin: 0 auto;\n  }\n  .copy-right {\n    padding-top: 35px;\n  }\n  .navbar-toggler {\n    border: 0px;\n  }\n  .navbar-toggler:focus {\n    box-shadow: none;\n  }\n  .intelligence-right {\n    float: none;\n    padding: 20px 8px 20px 8px;\n  }\n  .intelligence-text {\n    text-align: center;\n  }\n  .logout-view {\n    right: -30px;\n  }\n  .grid {\n    grid-template-columns: repeat(1, 1fr);\n  }\n}\n\n@media only screen and (min-width: 781px) and (max-width: 1021.98px) {\n  .bottom-cards {\n    margin-top: -50px;\n  }\n  .w-20 {\n    width: 31%;\n  }\n  .nav-end {\n    padding-top: 20px;\n    text-align: right;\n  }\n  .navbar-toggler:focus {\n    box-shadow: none;\n  }\n  .intelligence-right {\n    padding: 29px 0px 15px 28px;\n  }\n  .logout-view {\n    right: -30px;\n  }\n  .grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n/* Responsiveness:End */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
